import { FC } from "react";
import Search from "../../components/UI/Icons/Search";

const NotFoundLoggedIn: FC = () => {
  return (
    <div className="pt-80px d-flex flex-column align-items-center justify-content-center gap-20 text-center">
      <div className="w-60px h-60px bg-teal-light rounded-circle d-flex align-items-center justify-content-center">
        <Search size={40} />
      </div>
      <div className="fs-30 fw-400 text-black">Page not found</div>
      <div className="fs-16 fw-400 text-black">
        This page link might be broken or has been removed.
      </div>
      <div className="fs-16 fw-400 text-black">
        Please try reloading the{" "}
        <span className="fw-700 text-decoration-underline cursor-pointer">
          Jobs Page
        </span>
        .
      </div>
    </div>
  );
};

export default NotFoundLoggedIn;
